import { Box } from "@mui/material";
import ThemeContext from "components/app/Context";
import React, { useContext } from "react";
import { useAppSelector } from "redux/hooks";
import { tokens } from "styles/Tokens";
import { functionalAreaIdToName } from "utils/CommonFunctions";
import Chip from "./Chip";

interface Props {
  functionalAreaIds: any;
  showAbbrv?: boolean;
  innerRef?: any;
  chipCount?: number;
  direction?: "row" | "column";
}

function FunctionalAreas(props: Props) {
  const { functionalAreaIds = [], showAbbrv = false, innerRef, direction = "row", chipCount = 0, ...rest } = props;
  const functionalAreaList: any = useAppSelector((state) => state.functionalAreas.list);
  const { isMobileScreen } = useContext(ThemeContext);
  let arr = functionalAreaIds ? [...functionalAreaIds] : [];

  if (functionalAreaIds?.length > (isMobileScreen ? 1 : 3) && chipCount) {
    arr = functionalAreaIds && [...functionalAreaIds].slice(0, chipCount);
  }
  return (
    <Box
      component="div"
      sx={{
        display: "flex",
        flexDirection: direction,
        flexWrap: "wrap",
        gap: "8px",
        alignItems: "center",
        height: " 100%",
        justifyContent: direction === "column" ? "space-around" : ""
      }}
      {...rest}
      ref={innerRef}
    >
      {arr?.map((functionalArea: any) => {
        return (
          <Chip
            key={functionalArea}
            label={functionalAreaIdToName(functionalArea, functionalAreaList, showAbbrv)}
            backgroundColor="transparent"
            color={tokens.Text.General.Secondary}
            borderColor={tokens.Border.General.Secondary}
          />
        );
      })}
    </Box>
  );
}

const WrappedMyComponent = React.forwardRef(function WrappedMyComponent(props: Props, ref) {
  return <FunctionalAreas {...props} innerRef={ref} functionalAreaIds={props.functionalAreaIds} />;
});

export default WrappedMyComponent;
